import { combineReducers } from "@reduxjs/toolkit";
/* Importing Sub Reducers */
import UIPageReducer from "./slices/ui_page_slice";
import UIStatesReducer from "./slices/ui_states_slice";

const RootStateReducer = combineReducers({
  UIPage: UIPageReducer,
  UIStates: UIStatesReducer,
});

export default RootStateReducer;
